module.exports = __webpack_public_path__ + "img/account-white.1f8c060a.svg";